import * as React from "react";
import * as ReactDOM from "react-dom";
import * as moment from "moment";
import { NotificationType } from "../../enumerations";
import { IUserNotification } from "../../models/get";

interface IProperties
{
    /**
     * Der gebundene Datensatz.
     */
    notification: IUserNotification,

    /**
     * Wird ausgeführt, sobald auf die Benachrichtigung geklickt wird.
     */
    onClick?: (notification?: IUserNotification) => void,

    /**
     * Wird ausgeführt, sobald auf die Benachrichtigung Doppel geklickt wird.
     */
    onDoubleClick?: (notification?: IUserNotification) => void,

    /**
     * Wird ausgeführt, sobald auf den Remove Button geklickt wird.
     */
    onRemove?: (notification?: IUserNotification) => void
}

interface IState
{
    /**
     * Gibt an, ob der Button zum entfernen der Benachrichtigung, dargestellt werden soll.
     */
    isRemoveButtonVisible?: boolean
}

export class Notification extends React.Component<IProperties, IState>
{
    /**
     * Erstellt eine neue Instanz der Klasse @see Notification.
     * @param props Alle gesetzten Eigenschaften.
     */
    constructor(props: IProperties)
    {
        super(props);
        this.state = {
            isRemoveButtonVisible: false
        }
    }

    /**
     * Gibt das richtige Datums Anzeigeformat zurück.
     * @param date Das Datum welches formatiert werden soll.
     */
    private getDate(date: moment.Moment): string
    {
        if (date.isSame(moment(), "day"))
        {
            return date.format("HH:mm");
        }
        else
        {
            return date.format("L");
        }
    }

    /**
     * Wird ausgefürt, sobald auf die Benachrichtigung geklickt wird.
     * @param e Das auslösende Ergeignis.
     */
    private onClick = (e: React.MouseEvent<HTMLElement>): void =>
    {
        const { onClick, notification } = this.props;
        onClick && onClick(notification);
    }

    /**
     * Wird ausgefürt, sobald auf die Benachrichtigung doppel geklickt wird.
     * @param e Das auslösende Ergeignis.
     */
    private onDoubleClick = (e: React.MouseEvent<HTMLElement>): void =>
    {
        const { onDoubleClick, notification } = this.props;
        onDoubleClick && onDoubleClick(notification);
    }

    /**
     * Wird ausgefürt, sobald auf den "Entfernen" Button der Benachrichtigung geklickt wird.
     * @param e Das auslösende Ergeignis.
     */
    private onRemoveClick = (e: React.MouseEvent<HTMLElement>): void =>
    {
        const { onRemove, notification } = this.props;
        onRemove && onRemove(notification);
    }

    /**
     * Rendert diese Komponente.
     */
    public render(): JSX.Element
    {
        const { notification, onClick, onDoubleClick, onRemove } = this.props;
        const { isRemoveButtonVisible } = this.state;

        if (notification == null)
            return null;

        var classNames: string[] = ["item"];
        var headerIcon: string;
        var headerText: string;
        var content: JSX.Element = null;

        switch (notification.notification_type)
        {
            case NotificationType.eventCreated:
                {
                    classNames.push("-info");
                    headerIcon = "plus";
                    headerText = "Ein Termin wurde erstellt.";
                    content = (
                        <span>
                            <span className="textDecorator">{notification.notifier_fullname}</span> hat den Termin <span className="textDecorator" style={{ fontWeight: "bold" }}>{notification.event_subject + " - #" + notification.event_id}</span> erstellt.
                        </span>
                    );
                }
                break;
            case NotificationType.eventEdited:
                {
                    classNames.push("-info");
                    headerIcon = "information";
                    headerText = "Ein Termin wurde bearbeitet.";
                    content = (
                        <span>
                            <span className="textDecorator">{notification.notifier_fullname}</span> hat den Termin <span className="textDecorator" style={{ fontWeight: "bold" }}>{notification.event_subject + " - #" + notification.event_id}</span> bearbeitet.
                        </span>
                    );
                }
                break;
            case NotificationType.eventDeleted:
                {
                    classNames.push("-danger");
                    headerIcon = "alert";
                    headerText = "Ein Termin wurde gelöscht.";
                    content = (
                        <span>
                            <span className="textDecorator">{notification.notifier_fullname}</span> hat den Termin <span className="textDecorator" style={{ fontWeight: "bold" }}>{notification.event_subject + " - #" + notification.event_id}</span> gelöscht.
                        </span>
                    );
                }
                break;
            case NotificationType.eventCommented:
                {
                    classNames.push("-info");
                    headerIcon = "comment-text-outline";
                    headerText = "Ein Kommentar wurde erstellt.";
                    content = (
                        <span>
                            <span className="textDecorator">{notification.notifier_fullname}</span> hat Sie in einem Kommentar erwähnt oder einen Kommentar zu einen Ihrer Termine geschrieben.
                        </span>
                    );
                }
                break;
        }

        return (
            <div
                className={classNames.join(" ")}
                onClick={this.onClick}
                onDoubleClick={this.onDoubleClick}>
                <i
                    className="closeBtn mdi mdi-close mdi-18px"
                    title="Als gelesen markieren und entfernen"
                    onClick={this.onRemoveClick}></i>
                <div className="headerContainer">
                    <i className={`headerIcon mdi mdi-24px mdi-${headerIcon}`}></i>
                    <span className="headerText">{headerText}</span>
                    {notification.has_been_read && <i className="headerRead mdi mdi-check"></i>}
                    <time
                        className="headerTime"
                        dateTime={moment(notification.create_date).format()}
                        title={moment(notification.create_date).format("LLLL")}>
                        {this.getDate(moment(notification.create_date))}
                    </time>
                </div>
                <div className="itemContent">
                    {content}
                </div>
            </div>
        );
    }
}